import { QueryFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { fetchBorrowerScopedList } from './fetchBorrowerScopedList';
import type { LosEntry } from 'src/utils/income/formula/los';
import type { GetLoanExtractedValuesParams } from './getLoanExtractedValues';

/** One LOS (Encompass) field value on a loan, as `[los:ID]` reads it --
 *  already narrowed to the requested person, and tagged with its Encompass
 *  job when it is an employment field (see mos-mvp listLoanLosValues.ts). */
export interface LoanLosValue extends LosEntry {
  name: string;
}

/** Same `borrowerPairId` + `scope` narrowing as the extracted values. */
export type GetLoanLosValuesParams = GetLoanExtractedValuesParams;

const getLoanLosValues: QueryFunction<
  LoanLosValue[],
  ['/loans/los-values', GetLoanLosValuesParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) return await mock([]);

  return fetchBorrowerScopedList<LoanLosValue>('los-values', params);
};

export default getLoanLosValues;
